// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1anfo","itemTitle":"ClientEmergencyInfo_itemTitle__mipF2","itemText":"ClientEmergencyInfo_itemText__KzhVK"};